module.exports = __webpack_public_path__ + "img/app_korat_1.e5c81974.jpg";